import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import axios from "../../../../axios/index";
import { Link, useLocation, useHistory } from "react-router-dom";

// context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import BlogDrowDown from "../AddBlog/BlogDrowDown";
import EditBlogImg from "./EditBlogImg";
import AddBlogDatePicker from "../AddBlog/AddBlogDatePicker";
import SubmebuDropdown from "../AddBlog/SubmebuDropdown";
import Checkbox from "@mui/material/Checkbox";
import { Editor } from "@tinymce/tinymce-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// styles
import styles from "../AddBlog/AddBlog.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import btnStyles from "../BlogDetailManagment/BlogDetailManagment.module.css";

// images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
import AddedImg from "./AddedImg";

const EditBlog = () => {
  const { state } = useLocation();
  const history = useHistory();
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const editorRef = useRef(null);
  const [images, setImages] = useState([]);
  const [blogImg, setBlogImg] = useState();
  const [releaseDate, setReleaseDate] = useState({
    date: "",
    dateUpdate: false,
  });
  const [selectedParent, setSelectedParent] = useState({
    name: "",
    id: "",
  });
  const [selectedSubParent, setSelectedSubParent] = useState({
    name: "",
    id: "",
  });
  const [editorData, setEditorData] = useState();
  const [addBlogData, setAddBlogData] = useState({
    title: "",
    slug: "",
    categoryId: "",
    subcategoryId: "",
    seoTitle: "",
    seoDescription: "",
    seoKeywords: "",
    seoIndexPage: false,
    seoCanonical: "",
    seoSchema: "",
    videoLink: "",
  });
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  useMemo(() => addBlogData, [addBlogData]);

  const changeHandler = event => {
    if (event.target.name === "slug") {
      let value = event.target.value;
      value = value.replace(/[^A-Za-z-0-9]/gi, " ");
      setAddBlogData(prev => {
        return { ...prev, slug: value };
      });
    } else if (event.target.id === "checkbox") {
      setAddBlogData(prev => {
        return { ...prev, seoIndexPage: event.target.checked };
      });
    } else {
      setAddBlogData(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  };

  useEffect(() => {
    const dataHandler = async () => {
      const getApiData = await axios.get(`Article/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      const apidData = getApiData.data.data;
      setAddBlogData(prev => {
        return {
          ...prev,
          title: apidData.title,
          slug: apidData.slug,
          seoTitle: apidData.seoData.metaTitle,
          seoDescription: apidData.seoData.metaDescription,
          seoKeywords: apidData.seoData.metaDescription,
          metaKeyWords: apidData.seoData.metaDescription,
          seoIndexPage: apidData.seoData.indexPage,
          seoCanonical: apidData.seoData.canonical,
          seoSchema: apidData.seoData.schema,
          videoLink: apidData.aparatVideoUrl,
        };
      });
      setSelectedParent({ name: apidData.mainCategory.categoryTitle, id: apidData.mainCategory.id });
      setSelectedSubParent({ name: apidData.subCategory.categoryTitle, id: apidData.subCategoryId });
      setBlogImg(apidData.imageName);
      setReleaseDate(prev => {
        return { ...prev, date: apidData.dateRelease, dateUpdate: false };
      });
      setEditorData(apidData.body);
      setIsLoading(false);
    };
    dataHandler();
  }, [state.id, userToken]);
  // console.log(releaseDate.date)

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <ToastContainer
        position="top-right"
        autoClose={9000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-0 ${Dstyles.file_cards_container}`}>
                <DashboardHeader setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} onClick={() => setModalShow(true)} />
                <form onSubmit={e => e.preventDefault()} className="w-100 px-3 d-flex justify-content-start align-items-center flex-column" dir="rtl">
                  {/* <HomeNavbar /> */}
                  <div className="container py-3 w-100 d-flex align-items-center justify-content-start mb-4">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2 pointer" src={arrowIcon} alt="icon" />
                    </a>
                    <h4 className={`mb-0 ${styles.title_bold}`}>ویرایش مقاله</h4>
                  </div>
                  <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                    <h4 className={`mb-4 ${styles.title_text_black}`}>افزودن عکس</h4>
                    {blogImg ? <AddedImg images={blogImg} setImages={setBlogImg} /> : <EditBlogImg images={images} setImages={setImages} />}
                  </div>
                  <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>لینک SRC ویدیو</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="videoLink" value={addBlogData.videoLink} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>عنوان مقاله</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="title" value={addBlogData.title} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>عنوان مقاله(انگلیسی)</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="slug" value={addBlogData.slug} onChange={changeHandler} />
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap">
                      <BlogDrowDown parent selectedParent={selectedParent} setSelectedParent={setSelectedParent} userToken={userToken} />
                      <SubmebuDropdown selectedSubParent={selectedSubParent} setSelectedSubParent={setSelectedSubParent} id={selectedParent?.id} />
                      <AddBlogDatePicker data={releaseDate} setData={setReleaseDate} isEdit />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>متن مقاله</h4>
                      <Editor
                        tinymceScriptSrc={`${process.env.PUBLIC_URL}/assets/tinymce/tinymce.min.js`}
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        initialValue={editorData && editorData}
                        init={{
                          height: 450,
                          width: "100%",
                          menubar: true,
                          directionality: "rtl",
                          resize: false,
                          plugins: [
                            "advlist",
                            "autolink",
                            "lists",
                            "link",
                            "anchor",
                            "code",
                            "charmap",
                            "preview",
                            "anchor",
                            "searchreplace",
                            "visualblocks",
                            "fullscreen",
                            "insertdatetime",
                            "table",
                            "help",
                            "wordcount",
                            "image",
                          ],
                          toolbar:
                            "undo redo | casechange blocks | bold italic backcolor | " +
                            "alignleft aligncenter alignright alignjustify | " +
                            "bullist numlist checklist outdent indent | removeformat | a11ycheck code table help",
                          content_style: "body { font-family:Vazir,Arial,sans-serif; font-size:14px, direction:rtl }",
                        }}
                      />
                      {/* <button onClick={log}>Log editor content</button> */}
                    </div>
                  </div>
                  <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                    <h4 className={`mb-3 ${styles.title_text_black}`}>اطلاعات مربوط به سئو</h4>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>seoTitle</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="seoTitle" value={addBlogData.seoTitle} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>seoDescription</h4>
                      <input
                        className={`w-100 ${styles.input}`}
                        type="text"
                        name="seoDescription"
                        value={addBlogData.seoDescription}
                        onChange={changeHandler}
                      />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>seoKeywords</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="seoKeywords" value={addBlogData.seoKeywords} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-2 ${styles.title_text_gray}`}>seoIndexPage</h4>
                      <Checkbox
                        checked={addBlogData.seoIndexPage}
                        id="checkbox"
                        onClick={changeHandler}
                        inputProps={{ "aria-label": "controlled" }}
                        size="medium"
                      />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>seoCanonical</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="seoCanonical" value={addBlogData.seoCanonical} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h4 className={`mb-3 ${styles.title_text_gray}`}>seoSchema</h4>
                      <input className={`w-100 ${styles.input}`} type="text" name="seoSchema" value={addBlogData.seoSchema} onChange={changeHandler} />
                    </div>
                  </div>
                  <div className="container py-3 w-100 d-flex align-items-center justify-content-md-end justify-content-center mb-4">
                    <button className={`ms-2 border-danger ${btnStyles.button_delete}`} onClick={deleteHandler}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash3 text-danger ms-2"
                        viewBox="0 0 16 16">
                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                      </svg>
                      حذف
                    </button>

                    {btnLoader ? (
                      <div className={Dstyles.btn_loader_container}>
                        <div className={Dstyles.btn_spinner}></div>
                      </div>
                    ) : (
                      <button className={styles.submit_btn} type="submit" onClick={postHandler}>
                        ویرایش مقاله
                      </button>
                    )}
                  </div>
                </form>
                {/* </div> */}
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu blog blogs setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 9000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 9000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function deleteHandler() {
    setBtnLoader(true);
    try {
      notify("درحال حذف", "success");
      const apiData = await axios.delete(
        `Article?articleId=${state.id}`,
        // data,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      notify("مقاله با موفقیت حذف شد", "success");
      history.replace("/blog-dashboard");
    } catch (error) {
      notify("خطای سرور", "error");
      history.replace("/blog-dashboard");
    }
    setBtnLoader(false);
  }

  async function postHandler() {
    const inputData = addBlogData.seoCanonical;
    const linkRegex = /^(http|https):\/\/[^ "]+$/;
    if (inputData && !linkRegex.test(inputData)) {
      notify("باید لینک باشد seoCanonical", "error");
    } else {
      setBtnLoader(true);
      try {
        notify("درحال ویرایش", "success");
        var data = new FormData();
        data.append("Id", state.id);
        data.append("Title", addBlogData.title);
        data.append("Slug", addBlogData.slug);
        data.append("Body", editorRef.current.getContent());
        data.append("ImageName", images == "" ? blogImg : images[0].file);
        data.append("CategoryId", selectedParent.id);
        data.append("SubCategoryId", selectedSubParent.id);
        data.append("SeoData.MetaTitle", addBlogData.seoTitle);
        data.append("SeoData.MetaDescription", addBlogData.seoDescription);
        data.append("SeoData.MetaKeyWords", addBlogData.seoKeywords);
        data.append("SeoData.IndexPage", addBlogData.seoIndexPage);
        data.append("SeoData.Canonical", addBlogData.seoCanonical);
        data.append("SeoData.Schema", addBlogData.seoSchema);
        data.append(
          "DateRelease",
          releaseDate.dateUpdate ? `${releaseDate.date.year}/${releaseDate.date.month.number}/${releaseDate.date.day}` : releaseDate.date
        );
        data.append("AparatVideoUrl", addBlogData.videoLink ? addBlogData.videoLink : "");
        const apiData = await axios.put("Article", data, {
          headers: { authorization: "Bearer " + userToken },
        });
        notify("مقاله با موفقیت ویرایش شد", "success");
        history.replace("/blog-dashboard");
      } catch (error) {
        notify("خطای سرور", "error");
      }
      setBtnLoader(false);
    }
  }
};

export default EditBlog;
